import { NgModule } from '@angular/core';
import { MdSelectModule } from '@angular/material';
import { SharedModule } from '../../shared/shared.module';
import { MomentModule } from 'angular2-moment';
import { CentreRoutingModule } from './centre.routing';
import { DatePickerModule} from '../../components/date-picker/date-picker.module';

import { AddUserComponent } from './add-user/add-user.component';
import { ManageUserComponent } from './manage-user/manage-user.component';
import { EditUserPopupComponent } from './manage-user/edit-user-popup.component';
import { AssignUserListComponent } from './assign-user/assign-user-list.component';
import { AssignUserPopupComponent } from './assign-user/assign-user-popup.component';
import { ManageCompanyAccountsComponent } from './manage-company-accounts/manage-company-accounts-list.component';
import { ModifyCompanyAccountPopupComponent } from './manage-company-accounts/modify-company-account-popup.component';
import { ManageCentreComponent } from './manage-centre/manage-centre-list.component';
import { CentrePopupComponent } from './manage-centre/centre-popup.component';
import { ManagePatientUserComponent } from './manage-patient-user/manage-patient-list.component';
import { ModifyPatientPopupComponent } from './manage-patient-user/modify-patient-popup.component';
import { ManagePriceComponent } from './manage-price/manage-price-list.component';
import { NewsMemoComponent } from './news-memo/news-memo.component';
import { ModifyNewPopUpComponent } from './manage-memo/modify-news-popup.component';
import { ManageVaccineComponent } from './manage-vaccine/manage-vaccine.component';
import { PatientInformationComponent } from './manage-patient-user/patient-information.component';
import { PatientInformationFormComponent } from './manage-patient-user/patient-information-form.component';
import { ClinicAccessComponent } from './manage-patient-user/clinic-access/clinic-access.component';
import { NewsMemoDetailsPopUpComponent } from './news-memo/news-memo-detail.popup.component';
import { ManageMemoComponent } from './manage-memo/manage-memo.component';
import { WorldTravelPopUpComponent } from './news-memo/world-travel-detail.popup.component';
import { ManageVaccineAddPopupComponent } from './manage-vaccine/manage-vaccine-add-popup.component';
import { ManageVaccineEditPopupComponent } from './manage-vaccine/manage-vaccine-edit-popup.component';
import { AddPricePopUpComponent } from './manage-price/add-price-popup.component';
import { EditPricePopUpComponent } from './manage-price/edit-price-popup.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { PatientInformationCopyComponent } from './manage-patient-user/patient-infomation-copy/patient-infomation-copy.component';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  declarations: [
    AddUserComponent,
    ManageCompanyAccountsComponent,
    ModifyCompanyAccountPopupComponent,
    ManageUserComponent,
    EditUserPopupComponent,
    AssignUserListComponent,
    AssignUserPopupComponent,
    ManageCentreComponent,
    CentrePopupComponent,
    ManagePatientUserComponent,
    ModifyPatientPopupComponent,
    CentrePopupComponent,
    ManagePriceComponent,
    NewsMemoComponent,
    ModifyNewPopUpComponent,
    ManageVaccineComponent,
    PatientInformationComponent,
    PatientInformationFormComponent,
    ClinicAccessComponent,
    NewsMemoDetailsPopUpComponent,
    ManageMemoComponent,
    WorldTravelPopUpComponent,
    ManageVaccineAddPopupComponent,
    ManageVaccineEditPopupComponent,
    AddPricePopUpComponent,
    EditPricePopUpComponent,
    PatientInformationCopyComponent
  ],
  imports: [
    CentreRoutingModule,
    SharedModule,
    MomentModule,
    DatePickerModule,
    InfiniteScrollModule,
    HttpClientModule,
    //QuillEditorModule
  ],
  entryComponents: [
    AssignUserPopupComponent,
    ModifyCompanyAccountPopupComponent,
    EditUserPopupComponent,
    CentrePopupComponent,
    ModifyPatientPopupComponent,
    ModifyNewPopUpComponent,
    PatientInformationFormComponent,
    ClinicAccessComponent,
    NewsMemoDetailsPopUpComponent,
    WorldTravelPopUpComponent,
    ManageVaccineAddPopupComponent,
    ManageVaccineEditPopupComponent,
    AddPricePopUpComponent,
    EditPricePopUpComponent,
    PatientInformationCopyComponent
  ],
  providers: [],
  bootstrap: [],
  exports: [NewsMemoComponent]
})
export class CentreModule { }



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/centre/centre.module.ts